export default __webpack_public_path__ + "static/media/3.7097b426.jpg";